export default __webpack_public_path__ + "static/g301-1365fc8b269777c9d85f384495b42935.jpg";